import { FormControl, IconButton, InputLabel, MenuItem, Select } from '@mui/material';
import { Box } from '@mui/system';
import { IconRefresh } from '@tabler/icons-react';
import { useDispatch, useSelector } from 'react-redux';
import { setCompanyMenuItems, setCompanyNo } from 'store/slice/SliceHeaderData';

const CompanyList = () => {

    // const theme = useTheme();
    /**
     * anchorRef is used on different componets and specifying one type leads to other components throwing an error
     * */
    // const anchorRef = useRef(null);


    const { loginState, loginUserInfo } = useSelector(state => state.auth);
    const { companyMenuItems, selectCompanyNo, contractDate } = useSelector(state => state.header);
    const dispatch = useDispatch();


    const handleChange = (event) => {
        console.log(event.target.value)
        dispatch(setCompanyNo(event.target.value));
    };

    const reloadCompanyList = () => {
        dispatch(setCompanyMenuItems()).then((data) => {
            localStorage.setItem('selectCompanyNo', JSON.stringify(data.payload[0].key));
        })
    }

    return (
        <Box display='flex' alignItems='center'>
            <IconButton onClick={reloadCompanyList}>
                <IconRefresh />
            </IconButton>
            <FormControl sx={{ width: '16rem' }}>
                <InputLabel id="select-management-company">회사선택:</InputLabel>
                <Select
                    labelId="select-management-company"
                    id="select-management-company"
                    value={selectCompanyNo}
                    label="회사명"
                    onChange={handleChange}
                    sx={{ textOverflow: 'ellipsis', whiteSpace: 'nowrap', overflow: 'hidden' }}
                >
                    {companyMenuItems.map((item) => (
                        <MenuItem key={item.key} value={item.value}>{item.text}</MenuItem>
                    ))}
                </Select>
            </FormControl>
        </Box>

    );
};

export default CompanyList;
